import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
    Container,
    Typography,
    List,
    ListItem,
    ListItemText,
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material';
import { styled } from '@mui/system';
import { toast } from 'react-toastify';

const StyledContainer = styled(Container)({
    backgroundColor: '#91bfdd',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
});

const StyledListItem = styled(ListItem)(({ index }) => ({
    backgroundColor: index % 2 === 0 ? '#ffffff' : '#e8eaf6',
    marginBottom: '5px',
    borderRadius: '4px',
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
}));

const StyledButton = styled(Button)({
    color: '#ffffff',
    backgroundColor: '#1976d2',
    '&:hover': {
        backgroundColor: '#155a8a',
    },
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
});

const StyledTextField = styled(TextField)({
    '& .MuiInputBase-root': {
        backgroundColor: '#ffffff',
        borderRadius: '4px',
    },
});

const Adminsettings = () => {
    const token = localStorage.getItem("calendar_admin");
    const [cities, setCities] = useState([]);
    const [open, setOpen] = useState(false);
    const [currentCity, setCurrentCity] = useState('');
    const [editIndex, setEditIndex] = useState(null);

    useEffect(() => {
        get_cities();
    }, []);

    const get_cities = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get/citynames`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setCities(response.data); // Set the fetched cities
        } catch (error) {
            console.error("Error fetching cities:", error.message);
            toast.error("Failed to fetch city names");
        }
    };

    const handleClose = () => {
        setOpen(false);
        setCurrentCity('');
        setEditIndex(null);
    };

    const edit_city = async (id, cityName) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/cityname_control/${id}/${cityName}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            toast.success(response.data.message);
            get_cities(); // Refresh the city list after editing
        } catch (error) {
            console.error("Error saving city:", error.message);
            toast.error(error.message);
        }
    };

    const handleAddCity = () => {
        if (currentCity) {
            edit_city('0', currentCity); // Use '0' or appropriate ID for new city
            handleClose();
        }
    };

    const handleEditCity = () => {
        if (currentCity && editIndex !== null) {
            const cityId = cities[editIndex]._id; // Get the city ID for updating
            edit_city(cityId, currentCity);
            handleClose();
        }
    };

    const openEditDialog = (city, index) => {
        setCurrentCity(city.cityname); // Set the current city name for editing
        setEditIndex(index);
        setOpen(true);
    };

    return (
        <StyledContainer>
            <Typography variant="h4" gutterBottom style={{ color: '#ffffff' }}>
                City List
            </Typography>
            <List>
                {cities.map((city, index) => (
                    <StyledListItem key={city._id} index={index}>
                        <ListItemText primary={city.cityname} style={{ color: '#333333' }} />
                        <StyledButton variant="outlined" onClick={() => openEditDialog(city, index)}>
                            Edit
                        </StyledButton>
                    </StyledListItem>
                ))}
            </List>
            <StyledButton variant="contained" onClick={() => setOpen(true)}>
                Add City
            </StyledButton>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle style={{ color: '#1976d2' }}>{editIndex !== null ? 'Edit City' : 'Add City'}</DialogTitle>
                <DialogContent>
                    <StyledTextField
                        autoFocus
                        margin="dense"
                        label="City Name"
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={currentCity}
                        onChange={(e) => setCurrentCity(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <StyledButton onClick={handleClose}>
                        Cancel
                    </StyledButton>
                    <StyledButton onClick={editIndex !== null ? handleEditCity : handleAddCity}>
                        {editIndex !== null ? 'Update' : 'Add'}
                    </StyledButton>
                </DialogActions>
            </Dialog>
        </StyledContainer>
    );
};

export default Adminsettings;
